import LaboratorySelection from 'components/LaboratorySelection';
import Login from 'content/pages/Auth/Login/Basic';
import useAuth from 'hooks/useAuth';
import { FC, ReactNode, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface AuthenticatedProps {
  children: ReactNode;
}

const Authenticated: FC<AuthenticatedProps> = (props: { children: React.ReactNode }) => {
  const { children } = props;
  const auth = useAuth();
  const location = useLocation();
  const [requestedLocation, setRequestedLocation] = useState<string | null>(
    null
  );

  if (!auth.isAuthenticated) {
    if (location.pathname !== requestedLocation) {
      setRequestedLocation(location.pathname);
    }
    return <Login />;
  }

  if (auth.requiresLaboratorySelection) {
    return <LaboratorySelection />;
  }

  if (requestedLocation && location.pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
};

export default Authenticated;
